import {
    ChangeDetectorRef,
    Component, OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {DataService} from "../../services/data.service";
import {FrontEndService} from "../../services/front-end.service";
import {LogService} from "../../services/log.service";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Page} from '../../model/page';
import {WorkSpaceService} from "../../services/work-space.service";
import * as moment from 'moment/moment';
import {UserManagementService} from "../../services/user-management.service";
import {StateService} from '@uirouter/angular';
import appConstants from "../../app.constants";
import tableDragger from 'table-dragger';

@Component({
    selector: 'app-project-tasks',
    templateUrl: './project-tasks.component.html',
    styleUrls: ['./project-tasks.component.scss']
})
export class ProjectTasksComponent implements OnInit, OnDestroy {

    @ViewChild('taskTable') taskTable: any;

    public modalRef: NgbModalRef;

    status = "All";
    searchString = "";
    closeResult: string;
    loading = false;
    taskViewOptions = {
        placeholder: 'Select User'
    };
    taskViews = [
        {
            id: '1',
            text: 'Admin View'
        },
        {
            id: '2',
            text: 'User View'
        }
    ];

    options = {
        placeholder: 'Select'
    };

    filterOptions = {
        placeholder: 'Filter'
    };

    page = new Page();
    projectTasks = [];

    filterText = {};
    showDatePicker = {};
    users = [];

    columns = [];

    sort = "id";
    filter = "";
    isAdmin = false;
    isAdminView = false;
    fullScreenMode = false;

    textAreaTemp = "";
    allColumns = [];
    fieldOrderColumns = [];
    fixedColumns = [];
    isLocked = false;
    lockedBy = 0;
    lockFetchInterval: any;
    showMultiDatePicker = false;
    settings = {};

    constructor(
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private workSpaceService: WorkSpaceService,
        private userManagementService: UserManagementService,
        private cdr: ChangeDetectorRef,
        private stateService: StateService,
        public modalService: NgbModal,
        private logService: LogService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 10;
        this.page.totalElements = 0;
        this.page.totalPages = 0;
    }

    ngOnInit() {
        if (parseInt(this.dataService.currentUser['role'], 10) === 0 || parseInt(this.dataService.currentUser['role'], 10) === 1) {
            this.isAdmin = true;
            this.isAdminView = true;
        }
        this.getUsers();
    }

    ngOnDestroy(): void {
        this.stopFetchingLocks();
    }

    getUsers() {
        this.loading = true;
        this.userManagementService.getUsers((users) => {
            this.loading = false;
            this.users = users;
            this.startFetchingLocks();
        });
    }

    startFetchingLocks() {
        this.getLock(false);
        this.lockFetchInterval = setInterval(() => {
            this.getLock(true);
        }, appConstants.lockTimer);
    }

    stopFetchingLocks() {
        clearInterval(this.lockFetchInterval);
    }

    getLock(recursive: boolean) {
        // this.loading = true;
        this.workSpaceService.getLock((response) => {
            // this.loading = false;
            if (response.status) {
                if (response.data.status) {
                    this.isLocked = true;
                    this.lockedBy = response.data.locked_by;
                    this.front_end_service.showAlert("Alert", `System has been locked by ${this.getUserById(this.lockedBy)}`, false);
                }
            }

            if (!recursive) {
                this.getUserSettings();
            }
        });
    }

    deleteLock() {
        this.loading = true;
        this.workSpaceService.deleteLock((response) => {
            if (response.data.status) {
                this.isLocked = true;
                this.lockedBy = +response.data.locked_by;
            } else {
                this.isLocked = false;
                this.lockedBy = 0;
            }
            this.loading = false;
        });
    }

    getFields() {
        this.loading = true;
        this.workSpaceService.getFields(this.users, true, (response) => {
            this.loading = false;
            if (response.status) {
                this.allColumns = response.data;

                this.allColumns.forEach((column) => {
                    if (column.type !== 'date') {
                        this.filterText[column.prop] = "";
                    } else {
                        this.filterText[column.prop] = {
                            "start": [],
                            "end": []
                        };
                    }
                    this.showDatePicker[column.prop] = [true, true];

                    if(column['filled_by'] === 'admin') {
                        column['headerClass'] = 'admin-cell';
                    } else if (column['filled_by'] === 'reviewer') {
                        column['headerClass'] = 'reviewer-cell';
                    } else if (column['filled_by'] === 'analyst') {
                        column['headerClass'] = 'analyst-cell';
                    }
                    if (column.prop === 'actions') {
                        column['headerClass'] += ' text-center';
                    }
                });
                this.setFieldOrderColumns();
                this.applyColumns();

                this.setPage({ offset: 0 }, false);
            }
        }, this.settings);
    }

    onColumnResize(event) {
        let fieldWidths = {};
        if (this.settings.hasOwnProperty('fieldWidths')) {
            fieldWidths = this.settings['fieldWidths'];
        }

        fieldWidths[event['column'].prop] = event['newValue'];
        this.settings['fieldWidths'] = fieldWidths;
        this.setUserSettings();
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    setPage(pageInfo, isExport = false) {
        this.page.pageNumber = pageInfo.offset;
        this.loading = true;
        this.workSpaceService.getTasks(this.page.size, this.page.pageNumber * this.page.size, this.sort, this.filter, isExport, this.isAdmin, this.dataService.currentUser['id'], (response) => {
            if (response.status) {
                if (!isExport) {
                    if (response.data.length > 0) {
                        this.projectTasks = response.data;
                        this.setDatePickerDates();
                    } else {
                        // Adding empty task to show summary row in case there are no tasks
                        const task = {};
                        this.allColumns.forEach((column) => {
                            const key = column['prop'];
                            task[key] = "";
                        });
                        this.projectTasks.push(task);
                    }

                    this.page.totalElements = response.count;
                }
            }

            this.loading = false;
        })
    }

    setDatePickerDates() {
        const dateKeys = [];
        this.allColumns.forEach((column) => {
            if (column['type'] === "date") {
                dateKeys.push(column['prop']);
            }
        });

        this.projectTasks.forEach(task => {
            task['hide_status'] = (task['status'] === "QC Passed");
            task['rowExpanded'] = false;
            dateKeys.forEach(dateKey => {
                if (task[dateKey] != null) {
                    task[dateKey + "_picker"] = [moment(task[dateKey])];
                } else {
                    task[dateKey + "_picker"] = [];
                }
            });
        });
    }

    changeView(event) {
        this.isAdminView = event.value === "1";

        // const tasks = this.projectTasks;
        // this.projectTasks = [];
        const task = this.projectTasks[this.projectTasks.length-1];
        this.projectTasks.pop();
        this.projectTasks.push(task);
        this.cdr.markForCheck();
    }

    open(content) {
        this.setFieldOrderColumns();
        this.modalRef = this.modalService.open(content, { size: 'lg' });

        this.modalRef.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${DataService.getDismissReason(reason)}`;
        });
    }

    uploadDone() {
        // Function to handle upload done
    }

    exportData() {
        this.setPage({ offset: this.page.pageNumber }, true);
        if (!this.isLocked) {
            this.isLocked = true;
            this.lockedBy = +this.dataService.currentUser['id'];
        }
    }

    onSort(event) {
        // event was triggered, start sort sequence
        if (event.newValue !== "asc") {
            this.sort = "";
        } else {
            this.sort = "-";
        }

        this.sort += event.sorts[0].prop;

        this.setPage({ offset: this.page.pageNumber }, false);
    }

    toggle(col) {
        col.hidden = !col.hidden;
    }

    isChecked(col) {
        return col.hidden;
    }

    columnChanged(fieldOrder: Array<String>): boolean {
        let isChanged = false;
        this.allColumns.forEach((column) => {
            if (!fieldOrder.includes(column.prop)) {
                isChanged = true;
            }
        });
        return isChanged;
    }

    applyColumns() {
        this.loading = true;
        this.columns.length = 0;
        let fieldOrder = [];
        if (this.settings.hasOwnProperty('fieldOrder')) {
            fieldOrder = this.settings['fieldOrder'];
        }

        if (fieldOrder.length !== this.allColumns.length || this.columnChanged(fieldOrder)) {
            fieldOrder = [];
            this.allColumns.forEach((column) => {
                fieldOrder.push(column.prop);
            });
        }

        const fieldView = {};

        fieldOrder.forEach((field) => {
            this.allColumns.forEach((column) => {
                if (column.prop === field) {
                    fieldView[column.prop] = column.hidden;
                    if (!column.hidden || column.att) {
                        this.columns.push(column);
                    }
                }
            });
        });

        this.settings['fieldView'] = fieldView;
        this.loading = false;
    }

    applyFilter(columnName, allowEmpty = false) {
        const oldFilter = this.filter;
        this.filter = "";

        if(this.searchString.trim() !== "") {
            if (this.filter !== "") {
                this.filter += "&";
            }
            this.filter += "search=" + this.searchString;
        }

        for (const key in this.filterText) {
            if (this.filterText.hasOwnProperty(key) && this.filterText[key].length !== 0 && this.filterText[key] !== "null") {
                this.logService.printLog("Last character of filter", this.filter.substr(this.filter.length-1, 1));
                if (this.filter !== "" && this.filter.substr(this.filter.length-1, 1) !== "&") {
                    this.filter += "&";
                }

                // It will be an object in case of dates
                if (!(this.filterText[key] instanceof Object)) {
                    // Match exact if field is choice as filter with contains
                    if (this.filterText[key].trim() !== "") {
                        if (this.getColumnType(key) === 'choice') {
                            this.filter += key + "=" + this.filterText[key].trim();
                        } else {
                            this.filter += key + "__icontains=" + this.filterText[key].trim();
                        }
                    }
                } else {
                    if (this.filterText[key]['start'].length > 0) {
                        this.filter += key + "__gte=" + this.filterText[key]['start'][0].format("YYYY-MM-DD");
                    }
                    if (this.filterText[key]['end'].length > 0) {
                        if (this.filterText[key]['start'].length > 0) {
                            this.filter += "&"
                        }
                        this.filter += key + "__lte=" + this.filterText[key]['end'][0].format("YYYY-MM-DD");
                    }
                }

                // Remove extra &
                if (this.filter.substr(this.filter.length-1, 1) === "&") {
                    this.filter = this.filter.substr(0, this.filter.length-1);
                }
            }
        }
        if (oldFilter.trim() !== this.filter.trim()) {
            this.setPage({offset: this.page.pageNumber}, false);
        }
    }

    applyChoiceFilter(event, columnName) {
        this.filterText[columnName] = event.value;
        this.applyFilter(columnName);
    }

    applyDateFilter(columnName, i) {
        this.logService.printLog("Date filter - ", this.filterText[columnName]);
        this.showDatePicker[columnName][i] = true;
        this.applyFilter(columnName);
    }

    singleDateSelection(event, date) {
        // Empty function needed to enable day selection
    }

    getColumnType(prop) {
        for (let i = 0; i <= this.allColumns.length; i++) {
            const column = this.allColumns[i];
            if (column['prop'] === prop) {
                return column['type'];
            }
        }
    }

    getColumnChoices(prop, isField = false, selectedOption = "") {
        for (let i = 0; i <= this.allColumns.length; i++) {
            const column = this.allColumns[i];
            if (column['prop'] === prop) {
                let choices = JSON.parse(JSON.stringify(column['choices']));
                if (isField) {
                    choices.splice(0, 1);
                }
                if (prop === 'status' && selectedOption !== "") {
                    const newChoices = [];
                    for (const index in choices) {
                        const choice = choices[index];
                        if (choice.text === "Rework" || choice.text === "QC Passed" || choice.text === selectedOption) {
                            newChoices.push(choice);
                        }
                    }
                    choices = newChoices;

                }
                return choices;
            }
        }
    }

    importExcel(files) {
        this.loading = true;
        const data = {
            "file": files[0]
        };
        this.workSpaceService.importExcel(data, (response) => {
            this.loading = false;
            if (response.status) {
                if (this.isLocked) {
                    this.isLocked = false;
                    this.lockedBy = 0;
                }

                this.front_end_service.addToast("success", "data_imported_successfully", "success");
                this.setPage({ offset: this.page.pageNumber }, false);
            }
        });
        this.modalRef.close();
    }

    editTask(taskId) {
        let data = {};
        let isValid = true;
        this.projectTasks.forEach((task) => {
            if (task.id === taskId) {
                delete task['edit_view'];

                // Check if field is required
                this.allColumns.forEach((column) => {
                    // Check if required fields are filled in
                    if (column.required && (column['filled_by'] !== 'admin' && (column['filled_by'] === 'reviewer' && task['reviewer'] === this.dataService.currentUser['id'] || column['filled_by'] === 'analyst' && task['resource_analyst'] === this.dataService.currentUser['id']))) {
                        if (!task[column.prop] || task[column.prop] === null || task[column.prop].toString().trim() === "") {
                            this.front_end_service.addToast("error", column.name + this.front_end_service.en_json_data["is_required"], "error");
                            isValid = false;
                        }
                    }

                    // Check for length of the field text as excel does not allow more than this
                    if (task[column.prop] && task[column.prop].toString().length > 32767) {
                        this.front_end_service.addToast("error", this.front_end_service.en_json_data['string_longer_than_32767_are_not_allowed'] + column.name, "error");
                        isValid = false;
                    }

                    // Remove all the keys with null values
                    if (!task[column.prop]) {
                        delete task[column.prop];
                    }
                });
                data = task;
            }
        });

        if (isValid) {
            this.loading = true;
            this.workSpaceService.editTask(taskId, data, (response) => {
                if (response.status) {
                    this.front_end_service.addToast("success", "task_saved_successfully", "success");

                    this.projectTasks.forEach((task, index) => {
                        if (task.id === data['id']) {
                            for (const key in response.data) {
                                if (response.data.hasOwnProperty(key)) {
                                    data[key] = response.data[key];
                                }
                            }
                            this.setDatePickerDates();
                        }
                    });
                }
                this.loading = false;
            });
        }
    }

    resetDateFilters(columnName, event) {
        event.stopPropagation();
        this.filterText[columnName] = {
            "start": [],
            "end": []
        };

        this.applyFilter(columnName);
    }

    resetAllFilters() {
        this.allColumns.forEach((column) => {
            if (column.type !== 'date') {
                this.filterText[column.prop] = "";
            } else {
                this.filterText[column.prop] = {
                    "start": [],
                    "end": []
                };
            }
            this.showDatePicker[column.prop] = [true, true];
        });
        this.filter = "";
        this.searchString = "";
        this.setPage({ offset: this.page.pageNumber }, false);
    }

    selectValueChanged(event, row, columnName) {
        if (columnName === 'resource_analyst' || columnName === 'reviewer') {
            row[columnName] = parseInt(event.value, 10);
        } else {
            row[columnName] = event.value;
        }
    }

    onKeyDown(event, columnName) {
        if (event.key === "Enter") {
            this.applyFilter(columnName, true);
        }
    }

    downloadTemplate () {
        this.loading = true;
        this.workSpaceService.downloadTemplate((response) => {
            this.loading = false;
        });
    }

    toggleDatePicker(columnName, i) {
        if (i === 1) {
            this.showDatePicker[columnName][0] = true;
        } else {
            this.showDatePicker[columnName][1] = true;
        }
        this.showDatePicker[columnName][i] = !this.showDatePicker[columnName][i];
    }

    checkDateSelection(rowId, columnName) {
        this.projectTasks.forEach((task) => {
            if (task.id === rowId) {
                if (task[columnName + "_picker"][0]) {
                    task[columnName] = moment(task[columnName + "_picker"][0]._d).format("YYYY-MM-DD");
                } else {
                    task[columnName] = null;
                }
            }
        });
    }

    togglePopover(popover, value, column, index, columnName) {
        if (popover.isOpen()) {
            this.textAreaTemp = "";
            popover.close();
        } else {
            this.textAreaTemp = value;
            popover.open({
                'value': value,
                'column': column,
                'index': index,
                'columnName': columnName
            });
        }
    }

    toggleMultipleDatePicker(popover, row, column) {
        if (popover.isOpen()) {
            popover.close();
        } else {
            popover.open({
                popover,
                row,
                column
            });
        }
    }

    toggleExpandRow(row) {
        row['rowExpanded'] = !row['rowExpanded'];
    }

    textFieldChanged(event) {
        this.textAreaTemp = event;
    }

    textChanged(event, columnName, rowId) {
        this.projectTasks.forEach((task) => {
            if (task.id === rowId) {
                task[columnName] = event;
            }
        });
    }

    getUserById(id) {
        if (+this.dataService.currentUser['id'] === id) {
            return "You";
        }

        return this.users.filter((user) => {
            return user.id === id;
        })[0].name;
    }

    getUserSettings() {
        this.userManagementService.getUserSettings(+this.dataService.currentUser['id'], (response) => {
            if (response.status) {
                if (response.data.hasOwnProperty('fieldOrder') && Object.keys(response.data.fieldOrder).length > 0) {
                    this.settings['fieldOrder'] = response.data.fieldOrder;
                }

                if (response.data.hasOwnProperty('fieldWidths') && Object.keys(response.data.fieldWidths).length > 0) {
                    this.settings['fieldWidths'] = response.data.fieldWidths;
                }

                if (response.data.hasOwnProperty('fieldView') && Object.keys(response.data.fieldView).length > 0) {
                    this.settings['fieldView'] = response.data.fieldView;
                }
            }

            this.getFields();
        });
    }

    setUserSettings() {
        let fieldView = {};
        let fieldWidths = {};
        let fieldOrder = {};

        if (this.settings.hasOwnProperty('fieldView')) {
            fieldView = this.settings['fieldView'];
        }
        if (this.settings.hasOwnProperty('fieldWidths')) {
            fieldWidths = this.settings['fieldWidths'];
        }
        if (this.settings.hasOwnProperty('fieldOrder')) {
            fieldOrder = this.settings['fieldOrder'];
        }
        const data = {
            fieldView, fieldWidths, fieldOrder
        };
        this.loading = true;
        this.userManagementService.setUserSettings(data, +this.dataService.currentUser['id'], (response) => {
            this.loading = false;
        });
    }

    /**
     * Set row dragging on the table to adjust field positions
     */
    setDragging() {
        setTimeout(() => {
            const el = document.getElementById('table');
            const dragger = tableDragger(el, {
                mode: 'row',
                dragHandler: '.handle',
                onlyBody: true,
                // animation: 300
            });

            dragger.on('drop', (from, to) => {
                // Update position in allColumns array
                this.fieldOrderColumns = this.dataService.dragArrayElement(this.fieldOrderColumns, from, to);
            });
        }, 100);
    }

    setFieldOrderColumns() {
        this.fixedColumns = this.allColumns.filter((column) => {
            return !this.shouldShowColumnToReorder(column) && !column['col_is_hidden'] && column.prop !== 'actions';
        });

        this.fieldOrderColumns = this.allColumns.filter((column) => {
            return this.shouldShowColumnToReorder(column) && !column['col_is_hidden'] && column.prop !== 'actions';
        });
    }

    setFieldOrder() {
        const fieldOrder = [];
        const fieldView = {};

        this.fixedColumns.forEach((column) => {
            fieldOrder.push(column.prop);
            fieldView[column.prop] = column.hidden;
        });
        this.fieldOrderColumns.forEach((column) => {
            fieldOrder.push(column.prop);
            fieldView[column.prop] = column.hidden;
        });
        this.settings["fieldOrder"] = fieldOrder;
        this.settings["fieldView"] = fieldView;

        this.setUserSettings();
        this.getFields();
    }

    shouldShowColumnToReorder(column) {
        return column.prop !== 'id' && column.prop !== 'patent_number' && column.prop !== 'hyperlink';
    }

    showField(key) {
        return !appConstants.hiddenFields.includes(key);
    }
}
